<template>
  <div>
    <!-- 活动弹框 -->
    <div class="iframeUrlBox" v-if="iframeDialog">
       <iframe class="iframeUrl" frameborder='0' allowTransparency="true"   :class="{'filterbgs': routerPath =='/' && grayTheme }"   :src="iframeDialog" width="416px"
         height="576px;">
       </iframe>
       <div @click="closeiframe"  class="closeiframe"  :class="{'filterbgs': routerPath =='/' && grayTheme }" >
         <img src="/static/newcenter/animals/dialog5.png" alt="" srcset="">
       </div>
     </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        iframeDialog:'',
        routerPath:'/'
      }
    },
    computed:{
      grayTheme(){
        let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
        return data && data.grayTheme
      }
    },
    methods:{
      closeiframe(){
        this.iframeDialog = ''
      },
      openiframe(val){
        this.routerPath = this.$route.path;
        let token  = localStorage.getItem('token');
        if(token){
          // let iframeUrl = ` http://t-new.longzhu.com/act/#/activity/1?plat=pc&t=${token}&times=`+ new Date().getTime();  // 测试
          let iframeUrl = `https://m.longzhu.com/act/#/activity/1?plat=pc&t=${token}&times=`+ new Date().getTime();   // 生产
          this.iframeDialog = iframeUrl
        }
      },
    }
  }
</script>

<style lang="scss">
  ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;

    }
    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      //background-color: #8c8c8c;
      background-color: rgba(0, 0, 0, 0.25);
    }

    ::-webkit-scrollbar-track {
      background-color: #f6f6f6;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-track {
      border: 0;
  }
  .iframeUrlBox{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.55);
  }
  .closeiframe{
    position: fixed;
    left: 50%;
    cursor: pointer;
    top: 24vh;
    transform: translate(220px,-40px);
    img{
      transition: all .2s;
      width: 32px;
      height:32px;
    }
    img:hover{
      transform: rotate(90deg);
      transition: all .2s;
    }
  }
  .iframeUrl{
    position: fixed;
    left: 50%;
    top: 24vh;
    transform: translateX(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/pages/components/lz_activeDialog.vue